import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, checkProcessOrder } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const QRCode = Loadable({
    loader: () => import('./QRCode'),
    render(loaded, props) {
      const Component = connect(
        state => ({
          cashInQrCodeState: state.cashInQrCodeState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          checkProcessOrder
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/qrcode`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <QRCode {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
